import React from 'react'
import FormulaButton from '../formulaButton'
import ProcessYieldForm from '../../container/processYieldForm'

export default class ProcessYieldButton extends React.Component {
    render() {
        return (
            <div>
                <FormulaButton label="Process Yield" iconName="processYield">
                    <ProcessYieldForm />
                </FormulaButton>
            </div>
        )
    }
}